(() => {
  const init = (root) => {
    if (!root || root.dataset.faqInitialized === 'true') return;
    root.dataset.faqInitialized = 'true';

    const buttons = [...root.querySelectorAll('[data-faq-category]')];
    const items = [...root.querySelectorAll('[data-faq-item]')];
    const title = root.querySelector('[data-faq-category-title]');
    const search = root.querySelector('[data-faq-search]');
    const empty = root.querySelector('[data-faq-empty]');
    let activeCategory = buttons[0]?.dataset.faqCategory || '';

    const closeHidden = () => items.forEach((item) => { if (item.hidden) item.open = false; });
    const updateEmpty = () => { if (empty) empty.hidden = items.some((item) => !item.hidden); };
    const showCategory = (key, label) => {
      activeCategory = key;
      buttons.forEach((button) => {
        const active = button.dataset.faqCategory === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      items.forEach((item) => { item.hidden = item.dataset.category !== key; });
      closeHidden();
      const first = items.find((item) => !item.hidden);
      if (first) first.open = true;
      if (title) title.textContent = label || buttons.find((button) => button.dataset.faqCategory === key)?.dataset.categoryLabel || '';
      updateEmpty();
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      if (search) search.value = '';
      showCategory(button.dataset.faqCategory, button.dataset.categoryLabel);
    }));

    items.forEach((item) => item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach((other) => { if (other !== item && !other.hidden) other.open = false; });
    }));

    if (search) {
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        if (!query) {
          showCategory(activeCategory);
          return;
        }
        buttons.forEach((button) => { button.classList.remove('is-active'); button.setAttribute('aria-selected', 'false'); });
        items.forEach((item) => { item.hidden = !item.dataset.search.includes(query); });
        closeHidden();
        if (title) title.textContent = `Search results for “${search.value.trim()}”`;
        updateEmpty();
      });
    }

    root.querySelectorAll('[data-search-term]').forEach((trigger) => trigger.addEventListener('click', () => {
      if (!search) return;
      search.value = trigger.dataset.searchTerm || '';
      search.dispatchEvent(new Event('input', { bubbles: true }));
      root.querySelector('#faq-browser')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    if (buttons[0]) showCategory(buttons[0].dataset.faqCategory, buttons[0].dataset.categoryLabel);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-faq-support]')) init(scope);
    scope.querySelectorAll?.('[data-faq-support]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
